import React, { useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import BookingPage from './BookingPage';
import './BookingModal.scss';

const BookingModal = ({ isOpen, onClose }) => {
  const scrollYRef = useRef(0);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleEscapeKey = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;

    document.addEventListener('keydown', handleEscapeKey);

    // Save scroll position before locking
    scrollYRef.current = window.scrollY;

    // Use simple overflow hidden - avoids position:fixed layout shift on iOS
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [isOpen, handleEscapeKey]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="booking-modal-overlay" onClick={handleBackdropClick}>
      <div className="booking-modal-container" role="dialog" aria-modal="true">
        <button
          type="button"
          className="booking-modal-close"
          onClick={onClose}
          aria-label="Close booking modal"
        >
          &times;
        </button>
        <div className="booking-modal-content">
          <BookingPage onClose={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BookingModal;
